<template>
  <div id="app" :class="showVideoLoader ? 'disabled' : ''" @click="launchSound">
    <transition name="slide-fade">
      <FlashMessage v-if="show_flash_message" :message="flash_message" @closeFlash="hideFlashMessage"/>
    </transition>
    <Expiration @click.native="checkAdult()" v-show="displayExpiration()"/>
    <AgeSetting v-if="initialized" v-show="popAgeSetting"/>
    <div class="back" :class="{'blur-background': applyBlurAgeSetting()}" style="background-position: bottom;">
      <div class="main-container">
        <router-view v-if="initialized"/>
      </div>
      <SplashScreen v-if="!initialized"/>

			<img src="@/assets/icons/cloud.svg" class="cloud left" alt="cloud">
			<img src="@/assets/icons/cloud.svg" class="cloud right" alt="cloud">
    </div>
    <div class="video-player" v-show="videoPlayerDisplayed">
      <div class="close" id="buttonClose" @click="goBack()" >
        <font-awesome-icon icon="times" size="2x" :style="{ margin: '9px' }"/>
      </div>
      <video ref="videoPlayer" autoplay controls controlslist="nodownload"/>
    </div>
    <div v-show="showLoader || showVideoLoader" class="lds-facebook" :class="showVideoLoader ? '' : ''"><div>
    </div><div></div><div></div></div>
    <NotificationPopup v-if="isNotificationVisible.status" />
  </div>
</template>

<script>
  import SplashScreen from '@/components/SplashScreen.vue';
  import AgeSetting from '@/components/AgeSetting.vue';
  import Expiration from '@/components/Expiration.vue';
  import LoopSong from '@/utils/sounds';
  import locationService from '@/services/location.service';
  import userService from '@/services/user.service';
  import userUtil from '@/utils/user.util';
  import FlashMessage from '@/components/FlashMessage.vue';
  import { soundList, soundPlayer } from '@/utils/sounds';
  import partnerOrangeMixin from '@/mixins/orange';
  import NotificationPopup from '@/components/NotificationPopup.vue';
  import { Events } from '@/models/analytics';

  export default {
    components: { SplashScreen, AgeSetting, Expiration, FlashMessage, NotificationPopup },
    mixins: [partnerOrangeMixin],
    data() {
      return {
        showAgeSetting: false,
        initialized: false,
        videoPlayer: null,
        videoPlayerDisplayed: false,
        videoPlaying: false,
        videoRemainingTimeLimit: 0,
        videoTickIntervalId: null,
        flash_message: '',
        show_flash_message: false,
      };
    },
    computed: {
      isAgeSettingDisplayed() {
        return this.$store.getters['settings/isAgeSettingDisplayed'];
      },
      showExpiration() {
        return this.$store.getters['settings/showExpiration'];
      },
      getTimeLimit() {
        return this.$store.getters['settings/getTime'];
      },
      displayVideoLoader() {
        return this.$store.getters['settings/displayVideoLoader'];
      },
      displayLoader() {
        return this.$store.getters['settings/displayLoader'];
      },
      getToken() {
        return this.$store.getters['account/getToken'];
      },
      getPremium() {
        return this.$store.getters['account/getPremium'];
      },
      showVideoLoader: {
        get() {
          return this.displayVideoLoader;
        },
      },
      showLoader: {
        get() {
          return this.displayLoader;
        },
      },
      popAgeSetting: {
        get() {
          if (this.isAgeSettingDisplayed) {
            this.showAgeSetting = true;
          } else {
            this.showAgeSetting = false;
          }

          return this.showAgeSetting;
        },
      },
      isNotificationVisible() {
        return this.$store.getters['settings/getNotificationVisibility']
      }
    },
    methods: {
      // toggleSaveModal() {
      //   alert('slot action')
      // },
      setShowExpiration(val) {
        this.$store.dispatch('settings/setShowExpiration', val);
      },
      displayAgeSetting(val) {
        this.$store.dispatch('settings/displayAgeSetting', val);
      },
      setTimeLimit(val) {
        this.$store.dispatch('settings/setTimeLimit', val);
      },
      getUserInfo(val) {
        return this.$store.dispatch('account/getUserInfo', val);
      },
      checkUserKey(val) {
        return this.$store.dispatch('account/checkUserKey', val);
      },
      // DEV NOTE: investigate if there is a need for showing such flash message
      showFlashMessage(content) {
        this.flash_message = content;
        this.show_flash_message = true;
      },
      hideFlashMessage() {
        this.show_flash_message = false;
      },
      handleKeyboard(event) {
        event.preventDefault();
        try {
          switch (event.keyCode) {
            case VK_BACK_SPACE: {
              this.handleBack();
              // Do not handle back on Vewd TV as the remote manipulates the history already for this key code
              break;
            }
            case VK_BACK: {
              this.handleBack();
              // Do not handle back on Vewd TV as the remote manipulates the history already for this key code
              break;
            }
            case 461: {
                this.handleBack();
                break;
              }
            default: {
              if (this.videoRemainingTimeLimit <= 0 && this.showExpiration) {
                this.checkAdult();
              }
            }
          }
        } catch (error) {
          switch (event.code) {
            case 'Escape': {
              this.handleBack();
              break;
            }
          }
        }

        this.videoRemainingTimeLimit = this.getTimeLimit;
      },
      goBack() {
        soundPlayer(soundList.general);
        this.handleBack();
      },
      handleBack() {
        const currentRoute = this.$router.currentRoute;
        const lastRouteName = localStorage.getItem('lastRouteName');

        if (this.isAgeSettingDisplayed) {
          this.displayAgeSetting(false);
        } else if (currentRoute.name !== 'home' && lastRouteName) {
            lastRouteName === 'search'
              ? this.$router.replace({ name: lastRouteName })
              : this.$router.back();
        } else if (currentRoute.name !== 'home') {
          this.$router.replace({ name: 'home' });
        } else if (currentRoute.name === 'home') {
          const win = window.open('', '_self');
          win.close();
        }
      },
      displayExpiration() {
        return this.showExpiration;
      },
      checkAdult() {
        if (this.videoRemainingTimeLimit !== -60) {
          if (this.videoRemainingTimeLimit <= 0) {
            this.setShowExpiration(false);
            this.displayAgeSetting(true);
          }
        }
      },
      applyBlurAgeSetting() {
        return this.showAgeSetting || this.showExpiration;
      },
      launchSound() {
        LoopSong.play();
      },
      onVideoPlay() {
        if (this.videoPlayer.src && !this.videoPlaying) {
          this.videoRemainingTimeLimit = this.getTimeLimit;

          if (this.videoRemainingTimeLimit !== -60) {
            // Start video ticking if limit is set (not infinite)
            this.videoTickIntervalId = setInterval(() => {
              this.onVideoTick();
            }, 1000);
          }

          this.videoPlaying = true;
        }
      },
      onVideoPause() {
        if (this.videoPlaying) {
          this.clearVideoTick();
          this.videoPlaying = false;
        }
      },
      onVideoTick() {
        this.videoRemainingTimeLimit -= 1;
        this.setTimeLimit(this.videoRemainingTimeLimit);
        // Check if limit is reached
        if (this.videoRemainingTimeLimit <= 0) {
          this.clearVideoTick();
          this.videoRemainingTimeLimit = 0;
          this.videoPlayer.pause();
          this.setShowExpiration(true);
        }
      },
      clearVideoTick() {
        if (this.videoTickIntervalId) {
          // Clear video ticking
          clearInterval(this.videoTickIntervalId);
          this.videoTickIntervalId = null;

          // Update remaining time limit
          this.setTimeLimit(this.videoRemainingTimeLimit);
        }
      },
      resetAndCleanVideo() {
        this.clearVideoTick();
        this.videoPlayer.pause();
        this.videoPlaying = false;
        this.videoPlayer.removeAttribute('src');
        this.videoPlayer.srcObject = null;
      },
    },
    async mounted() {
      // check Auth
      const params = new URLSearchParams(window.location.search);

      if (params.has('key')) {
        await this.checkUserKey(params.get('key')).then((response) => {
          this.$store.dispatch('account/getUserInfo', response.token).then(() => {
            this.$store.dispatch('analytics/postAnalytics', Events.OPEN_APP, { root: true });
          });
        });
      }
      // localStorage.setItem('kidj_ut', 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJBdXRoZW50aWNhdGlvbiIsImlzcyI6ImtpZGpvU2VydmVyIiwiaWQiOjE0ODQxNCwiZXhwIjoxNzU1OTYyNjEzfQ.yidAc8nTxehiXMnc5lAhqHEiu0kmhzXh5iFPmy8z-mI-WtQNZWVO1JDoA7RIrEPdwuc8XA5HuK4vhy9dGxBRxg');
      if (this.getToken !== false && localStorage.getItem('kidj_ut') && !params.has('key')) {
        await this.$store.dispatch('account/getUserInfo', localStorage.getItem('kidj_ut')).then(() => {
          this.$store.dispatch('analytics/postAnalytics', Events.OPEN_APP, { root: true });
        });
      }
      await userService.refreshWeb().then((response) => {
        userUtil.setDeviceData(response);
      });

      this.initialized = true;
      this.launchSound();

      // Bind video player to document
      const anyDocument = document;
      anyDocument.videoPlayer = this.$refs.videoPlayer;
      this.videoPlayer = anyDocument.videoPlayer;
      this.videoPlayer.resetAndClean = this.resetAndCleanVideo;
      this.videoPlayer.addEventListener('play', this.onVideoPlay);
      this.videoPlayer.addEventListener('pause', this.onVideoPause);
      this.videoPlayerDisplayed = this.$route.name === 'player';

      document.addEventListener('keyup', this.handleKeyboard);
    },
    destroyed() {
      // Remove listeners
      this.videoPlayer.removeEventListener('play', this.onVideoPlay);
      this.videoPlayer.removeEventListener('pause', this.onVideoPause);

      document.removeEventListener('keyup', this.handleKeyboard);
    },
    watch: {
      $route() {
        this.videoPlayerDisplayed = this.$route.name === 'player';
      },
    },
  };
</script>

<style lang="scss">
  @font-face {
    font-family: "Nunito-ExtraBold";
    src: url('~@/assets/fonts/Nunito-ExtraBold.ttf') format('truetype');
  }

  @font-face {
    font-family: "Nunito-Regular";
    src: url('~@/assets/fonts/Nunito-Regular.ttf') format('truetype');
  }

  .lds-facebook {
    background-color: #fff;
    border-radius: 8px;
    bottom: 0;
    box-shadow: 1px 1px 10px 1px rgba(76, 76, 76, 0.44);
    display: inline-block;
    height: 80px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    z-index: 99999;
  }

  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 16px;
    background: #9AD5F0;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }

  .lds-facebook div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }

  .lds-facebook div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }

  .lds-facebook div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }

  @keyframes lds-facebook {
    0% {
      top: 8px;
      height: 64px;
    }

    50%,
    100% {
      top: 25px;
      height: 32px;
    }
  }

  // Handle iOS notch
  html { padding: env(safe-area-inset); }

  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  #app {
    height: 100%;
    width: 100%;
    position: relative;

    @media (orientation: landscape) {
      position: fixed;
    }
  }

  .main-container {
    position: absolute;
    z-index: 1;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    @supports (-webkit-overflow-scrolling: touch) {
      -webkit-overflow-scrolling: touch;
    }
  }

  .back {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: white url('~@/assets/backgrounds/main_bg.svg') no-repeat;
    background-size: cover;
  }

  .blur-background {
    height: 100%;
    width: 100%;
    filter: blur(12px);
  }

  .view {
    height: 100%;
    width: 100%;
  }

  .cloud {
    display: none;
    position: absolute;
    width: 115px;

    &.left {
      top: 55%;
      left: -47px;
    }

    &.right {
      top: 35%;
      right: -36px;
    }

    @media (max-width: 550px) {
      display: block;
    }
  }

  .video-player {
    height: 100%;
    position: relative;
    width: 100%;
    z-index: 100;
    overflow: hidden;
    left: 0px;
    right: 0px;

    video {
      height: 100%;
      width: 100%;
    }
  }

  .cc-revoke.cc-bottom {
    @media screen and (max-height: 850px) {
      display: none;
    }
    @media screen and (max-height: 600px) {
      display: none;
    }
    @media only screen and (max-width: 420px) {
      display: none;
    }
  }
</style>

<style scoped lang="scss">

  @mixin transition($transition) {
    -moz-transition: $transition;
    -o-transition: $transition;
    -webkit-transition: $transition;
    transition: $transition;
  }

  .close {
    background: white;
    border-radius: 25px;
    color: #fd9188;
    cursor: pointer;
    height: 50px;
    position: absolute;
    right: 25px;
    text-align: center;
    top: 25px;
    width: 50px;
    z-index: 110;

    &:active,
    &:focus,
    &:hover {
      background: #ddd;
      @include transition(background .2s ease);
    }
  }
.disabled {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: black; // Adjust for your needs
    z-index: 999; // Ensure it’s on top of everything
    pointer-events: auto; // Allow clicks on the overlay
  }
  pointer-events: none;
}
</style>
